import wx from 'weixin-js-sdk'
export default {
	_weixin_share: async function(obj){
		console.log("走了吗",obj);
		var formData = new FormData()
		formData.append('url', window.location.href)
		var config = {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}
		// 请求接口，获取相关参数 	
		var res = await this.$busihttp.post('/rr/lnec-web/index/wx.do',formData,config)
		console.log(res,"微信微信")
		
		// 判断接口是否请求成功
		if(res.data.code != 'succ'){
			console.log('微信接口请求失败！----');
			return
		}

		// 调用jssdk传递相关必须的参数
		var setShare = {
			debug: false, // 生产环境关闭debug模式
			appId:  res.data.appId, // 公众号Id
			timestamp: res.data.timestamp, // 时间戳
			nonceStr: res.data.nonceStr, // 签名随机字符串
			signature: res.data.signature,//签名
			jsApiList: [ //需要调用的js接口列表
				'onMenuShareTimeline', //分享给好友
            　　'onMenuShareAppMessage', //分享到朋友圈
			]
		}
		console.log(setShare,'----config配置');
		wx.config(setShare);

		console.log(wx);
		
		//  对相关的分享项进行设置
		wx.ready(function(){
			console.log({
				title: obj.title, 
				link: obj.link, 
				desc:obj.desc,
				imgUrl: obj.imgUrl},'----分享项配置');
			//朋友圈
			wx.onMenuShareTimeline({
				title: obj.title, 
				link: obj.link, 
				desc:obj.desc,
				imgUrl: obj.imgUrl,
				success: function(res) {
					console.log('已分享',res);
				},
				cancel: function(res) {
					console.log('已取消',res);
				},
				fail: function(res) {
					console.log('失败-0');
					alert(JSON.stringify(res));
				}
			});
			  
			//分享给朋友
			wx.onMenuShareAppMessage({
				title: obj.title, //标题
				desc:obj.desc, //描述
				link: obj.link, // 链接
				imgUrl: obj.imgUrl, // 图标
				success: function(res) {
					console.log('已分享',res);
				},
				cancel: function(res) {
					console.log('已取消',res);
				},
				fail: function(res) {
					console.log('失败-1');
					alert(JSON.stringify(res));
				}
			});
			console.log('----分享事件绑定完成---');
		});
	}
}